<div class="simple-solver" [class.latex-on-right]="config()?.latex_on_right">
  <div class="latex-panel">
    <dojo-super-latex [content]="currentContent()" padding="16px" />
    @if (resizable()) {
      <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>
    }
  </div>

  <div class="steps-panel">
    @for (step of stepsViewModel(); track $index; let i = $index) {
      <dojo-button
        fill="outline"
        size="s"
        class="step-button"
        [class.active]="currentStepIndex() === i"
        (click)="setStep(i)"
      >
        <span class="step-content">
          <span class="step-number">{{ i + 1 }}</span>
          <span class="step-text">
            <markdown katex [katexOptions]="katexOptions" class="step-title" [data]="step.title"></markdown>
            @if (step.decisions?.length) {
              <span class="step-decisions">
                @for (decision of step.decisions; track decision.condition_id) {
                  <span
                    class="step-decision"
                    [class.satisfied]="decision.satisfied"
                    [class.unsatisfied]="!decision.satisfied"
                  >
                    <span class="decision-icon">{{ decision.satisfied ? '✓' : '✗' }}</span>
                    <span class="decision-text">{{ decision.description }}</span>
                  </span>
                }
              </span>
            }
            @if (step.description) {
              <span class="step-description">
                <markdown katex [katexOptions]="katexOptions" [data]="step.description"></markdown>
              </span>
            }
          </span>
        </span>
      </dojo-button>
    }
  </div>
</div>
